import { DESTINATION_OPTIONS } from "./types";

const initialState = {
  destinationOptions: []
};
export function tourReducer(state = initialState, action) {
  switch (action.type) {

    case DESTINATION_OPTIONS:
      return { ...state, destinationOptions: action.payload };
    default:
      return state;
  }
}